import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getNameById'
})

export class GetNameByIdPipe implements PipeTransform {

    transform(parentList:any[], id: number) {
      const parent =  parentList.find((parent) => parent.id === id)
      if (!parent) {
        // we not found the parent
        return '';
      }
  
      return parent.name
    }
  }

